import { Video, convertPath, socket, hideSideMenu, room, electronConfig, isElectron, buttonSpam, live_stream, permissions} from './roomnew';
import moment from 'moment';
import axios from 'axios';
import KinoStreamService from '../features/stream/KinoStreamService';
import kinoTooltip from '../room/kinoTooltip';
export default class LocalRecording {
    constructor(){
        this.recorder;
        this.recordingData = [];
        this.recorderStream;
        this.isRecording = false;
        this.isPaused = true;
        this.modalAccepted = false;
        this.btnLabel="Kino Recorder";
        this.hasRecordingAvailability=false;
        this.forceStopped = false;
        // this.socket = socket
        // this.video = video
        this.isAvailable = false;
        this.disabled=false;
        this.recordedBy = {};
        this.recordingListTimeout = 0;
        this.AudioPlayer;
        this.optionList = $("#option-list");
        this.whoIsRecording = $("#whoRecordingList");

        //Recorder messages
        this.startedRecordingMessage = 'started recording this Kino';
        this.pausedRecordingMessage = 'paused recording this Kino';
        this.resumedRecordingMessage = 'resumed recording this Kino';
        this.stoppedRecordingMessage = 'stopped recording this Kino';
        this.forceStoppedRecordingMessage = 'recording was stopped by moderators';
        this.isRecordingMessage = ' is recording this Kino';
        this.mustHaveModerator = 'You must have moderator rights to record this Kino';

        // icons
        this.closeControlsIcon = `<i class="icofont-close icofont-1x"></i>`;
        this.kinoRecorderSvg = `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#032836"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" fill="#032836"/><circle cx="12" cy="12" r="5" fill="#032836"/></svg>`
        this.startSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="53" height="53" viewBox="0 0 53 53"><g transform="translate(-257.5 -1012.5)"><path d="M33,8a24.991,24.991,0,1,0,14.565,4.677A24.678,24.678,0,0,0,33,8Z" transform="translate(251 1006)" fill="none" stroke="#fff" stroke-width="3"/><path d="M22.944,8A14.944,14.944,0,1,0,37.889,22.944,14.942,14.942,0,0,0,22.944,8Z" transform="translate(261 1016.111)" fill="#c51a05"/></g></svg>`;
        this.pauseSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"><g transform="translate(-132 -746)"><g transform="translate(132 746)" fill="none"><path d="M25,0A25,25,0,1,1,0,25,25,25,0,0,1,25,0Z" stroke="none"/><path d="M 25 3 C 22.02869987487793 3 19.14785957336426 3.581260681152344 16.43753051757812 4.727638244628906 C 13.81813812255859 5.835540771484375 11.46506118774414 7.4222412109375 9.443649291992188 9.443649291992188 C 7.4222412109375 11.46506118774414 5.835540771484375 13.81813812255859 4.727638244628906 16.43753051757812 C 3.581260681152344 19.14785957336426 3 22.02869987487793 3 25 C 3 27.97130012512207 3.581260681152344 30.85214042663574 4.727638244628906 33.56246948242188 C 5.835540771484375 36.18186187744141 7.4222412109375 38.53493881225586 9.443649291992188 40.55635070800781 C 11.46506118774414 42.5777587890625 13.81813812255859 44.16445922851562 16.43753051757812 45.27236175537109 C 19.14785957336426 46.41873931884766 22.02869987487793 47 25 47 C 27.97130012512207 47 30.85214042663574 46.41873931884766 33.56246948242188 45.27236175537109 C 36.18186187744141 44.16445922851562 38.53493881225586 42.5777587890625 40.55635070800781 40.55635070800781 C 42.5777587890625 38.53493881225586 44.16445922851562 36.18186187744141 45.27236175537109 33.56246948242188 C 46.41873931884766 30.85214042663574 47 27.97130012512207 47 25 C 47 22.02869987487793 46.41873931884766 19.14785957336426 45.27236175537109 16.43753051757812 C 44.16445922851562 13.81813812255859 42.5777587890625 11.46506118774414 40.55635070800781 9.443649291992188 C 38.53493881225586 7.4222412109375 36.18186187744141 5.835540771484375 33.56246948242188 4.727638244628906 C 30.85214042663574 3.581260681152344 27.97130012512207 3 25 3 M 25 0 C 38.80712127685547 0 50 11.19287872314453 50 25 C 50 38.80712127685547 38.80712127685547 50 25 50 C 11.19287872314453 50 0 38.80712127685547 0 25 C 0 11.19287872314453 11.19287872314453 0 25 0 Z" stroke="none" fill="#c51a05"/></g><rect width="9" height="22" rx="2" transform="translate(146 760)" fill="#6e7679"/><rect width="9" height="22" rx="2" transform="translate(159 760)" fill="#6e7679"/></g></svg>`;
        this.resumeSvg = `<svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.5 1.5C20.5429 1.50202 14.7824 3.63194 10.2569 7.50583C5.73144 11.3797 2.73859 16.7428 1.81783 22.6283C0.897081 28.5138 2.109 34.5347 5.23513 39.6056C8.36127 44.6766 13.196 48.464 18.8679 50.2853C24.5397 52.1066 30.6756 51.842 36.1696 49.5391C41.6636 47.2361 46.1542 43.0464 48.8321 37.7252C51.51 32.4039 52.199 26.301 50.7749 20.5166C49.3508 14.7323 45.9073 9.64683 41.065 6.177C36.828 3.1146 31.7278 1.47689 26.5 1.5V1.5Z" stroke="#C51A05" fill="none" stroke-width="3"/><path d="M42 26.5L18.75 39.9234L18.75 13.0766L42 26.5Z" fill="#C51A05"/></svg>`;
        this.stopSvg = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve" fill="#e0e4e5"><path d="M500,10C229.4,10,10,229.4,10,500s219.4,490,490,490s490-219.4,490-490S770.6,10,500,10z M500,928.7C263.6,928.7,71.3,736.4,71.3,500C71.3,263.6,263.6,71.3,500,71.3c236.4,0,428.7,192.3,428.7,428.7C928.7,736.4,736.4,928.7,500,928.7z"/><path d="M622.5,316.2h-245c-33.8,0-61.2,27.4-61.2,61.2v245c0,33.8,27.4,61.3,61.2,61.3h245c33.8,0,61.3-27.4,61.3-61.3v-245C683.7,343.7,656.3,316.2,622.5,316.2z"/></svg>`;
        this.downloadReadySvg = `<svg class="ready-download-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 122.88"><defs><style>.cls-1{fill-rule:evenodd;}</style></defs><path class="cls-1" fill="#032836" d="M61.44,0A61.44,61.44,0,1,1,0,61.44,61.44,61.44,0,0,1,61.44,0Zm10.9,49.72a3.63,3.63,0,1,1,5.09,5.18L63.63,68.53a3.64,3.64,0,0,1-5.1,0L44.93,55.1A3.63,3.63,0,0,1,50,49.91l7.49,7.42.08-26.13a3.64,3.64,0,0,1,7.27.06l-.08,25.93,7.56-7.47ZM32.5,83.09l0-14.22a3.64,3.64,0,0,1,7.27.07l0,10.35q21.66,0,43.3,0l0-10.42a3.64,3.64,0,1,1,7.27.07l0,14.15h0a3.64,3.64,0,0,1-3.6,3.47q-25.32,0-50.59,0a3.63,3.63,0,0,1-3.6-3.47Z"/></svg>`
        // this.downloadReadySvgMinimize = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"><g id="XMLID_23_"><path fill="#fff" d="M154.389,255.602c0.351,0.351,0.719,0.683,1.103,0.998c0.169,0.138,0.347,0.258,0.52,0.388c0.218,0.164,0.432,0.333,0.659,0.484c0.212,0.142,0.432,0.265,0.649,0.395c0.202,0.121,0.4,0.248,0.608,0.359c0.223,0.12,0.453,0.221,0.681,0.328c0.215,0.102,0.427,0.21,0.648,0.301c0.223,0.092,0.45,0.167,0.676,0.247c0.236,0.085,0.468,0.175,0.709,0.248c0.226,0.068,0.456,0.119,0.684,0.176c0.246,0.062,0.489,0.131,0.739,0.181c0.263,0.052,0.529,0.083,0.794,0.121c0.219,0.031,0.435,0.073,0.658,0.095c0.492,0.048,0.986,0.075,1.48,0.075c0.494,0,0.988-0.026,1.479-0.075c0.226-0.022,0.444-0.064,0.667-0.096c0.262-0.037,0.524-0.068,0.784-0.12c0.255-0.05,0.504-0.121,0.754-0.184c0.223-0.057,0.448-0.105,0.669-0.172c0.246-0.075,0.483-0.167,0.724-0.253c0.221-0.08,0.444-0.152,0.662-0.242c0.225-0.093,0.44-0.202,0.659-0.306c0.225-0.106,0.452-0.206,0.672-0.324c0.21-0.112,0.408-0.239,0.611-0.361c0.217-0.13,0.437-0.252,0.648-0.394c0.222-0.148,0.431-0.314,0.644-0.473c0.179-0.134,0.362-0.258,0.536-0.4c0.365-0.3,0.714-0.617,1.049-0.949c0.016-0.016,0.034-0.028,0.049-0.044l70.002-69.998c5.858-5.858,5.858-15.355,0-21.213c-5.857-5.857-15.355-5.858-21.213-0.001l-44.396,44.393V25c0-8.284-6.716-15-15-15c-8.284,0-15,6.716-15,15v183.785l-44.392-44.391c-5.857-5.858-15.355-5.858-21.213,0c-5.858,5.858-5.858,15.355,0,21.213L154.389,255.602z"/><path fill="#fff" d="M315,160c-8.284,0-15,6.716-15,15v115H30V175c0-8.284-6.716-15-15-15c-8.284,0-15,6.716-15,15v130c0,8.284,6.716,15,15,15h300c8.284,0,15-6.716,15-15V175C330,166.716,323.284,160,315,160z"/></g></svg>`
        // this.downloadReadySvgMinimize = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 490 490" style="enable-background:new 0 0 490 490;" xml:space="preserve"><g><g><g><path fill="#fff" d="M245,0c-9.5,0-17.2,7.7-17.2,17.2v331.2L169,289.6c-6.7-6.7-17.6-6.7-24.3,0s-6.7,17.6,0,24.3l88.1,88.1c3.3,3.3,7.7,5,12.1,5c4.4,0,8.8-1.7,12.1-5l88.1-88.1c6.7-6.7,6.7-17.6,0-24.3c-6.7-6.7-17.6-6.7-24.3,0L262,348.4V17.1C262.1,7.6,254.5,0,245,0z"/><path fill="#fff" d="M462.1,472.9v-99.7c0-9.5-7.7-17.2-17.2-17.2s-17.2,7.7-17.2,17.2v82.6H62.2v-82.6c0-9.5-7.7-17.2-17.1-17.2s-17.2,7.7-17.2,17.2v99.7c0,9.5,7.7,17.1,17.2,17.1h399.8C454.4,490,462.1,482.4,462.1,472.9z"/></g></g></g></svg>`
        // this.downloadReadySvgMinimize = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 122.88"><defs><style>.cls-1{fill-rule:evenodd;}</style></defs><path class="cls-1" fill="#032836" d="M61.44,0A61.44,61.44,0,1,1,0,61.44,61.44,61.44,0,0,1,61.44,0Zm10.9,49.72a3.63,3.63,0,1,1,5.09,5.18L63.63,68.53a3.64,3.64,0,0,1-5.1,0L44.93,55.1A3.63,3.63,0,0,1,50,49.91l7.49,7.42.08-26.13a3.64,3.64,0,0,1,7.27.06l-.08,25.93,7.56-7.47ZM32.5,83.09l0-14.22a3.64,3.64,0,0,1,7.27.07l0,10.35q21.66,0,43.3,0l0-10.42a3.64,3.64,0,1,1,7.27.07l0,14.15h0a3.64,3.64,0,0,1-3.6,3.47q-25.32,0-50.59,0a3.63,3.63,0,0,1-3.6-3.47Z"/></svg>`
        this.downloadReadySvgMinimize = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 512 512"><g><g><path d="M480.6,341.4c-11.3,0-20.4,9.1-20.4,20.4v98.4H51.8v-98.4c0-11.3-9.1-20.4-20.4-20.4c-11.3,0-20.4,9.1-20.4,20.4v118.8    c0,11.3,9.1,20.4,20.4,20.4h449.2c11.3,0,20.4-9.1,20.4-20.4V361.8C501,350.5,491.9,341.4,480.6,341.4z"/><path d="m241,365.6c11.5,11.6 25.6,5.2 29.9,0l117.3-126.2c7.7-8.3 7.2-21.2-1.1-28.9-8.3-7.7-21.2-7.2-28.8,1.1l-81.9,88.1v-265.2c0-11.3-9.1-20.4-20.4-20.4-11.3,0-20.4,9.1-20.4,20.4v265.3l-81.9-88.1c-7.7-8.3-20.6-8.7-28.9-1.1-8.3,7.7-8.7,20.6-1.1,28.9l117.3,126.1z"/></g></g></svg>`

        //Controls
        this.recorderControls = null;
        this.controlPlayback = null;
        this.stopRecording = null;
        this.controlPlaybackIcon = null;
        this.stopRecordingIcon = null;

        //modal assets
        this.tipModal = null;
        this.modalTitle = 'Kino recorder';
        this.modalSubHeader = 'Kino uses Chrome\'s share screen feature for video recording';
        this.closeModalBtn = `<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10"><path fill="#032836" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path></svg>`;
        this.modalBodyHeaderText = 'Select the Kino tab you wish to record';
        this.modalBodySubHeaderText = 'Please check "Share audio" to record the Kino\'s audio';
        this.modalBodyBottomText = 'Your screen will not be shared';
        this.tipImage = isElectron ? '../../images/AudioRecordTip.png' : '..//images/AudioRecordTip.png';
        this.gumStream;
        this.gdmStream;

        //events call
        this.events()
        // this.addOptionButton(); we can activate this function call when we want to show the kino recorder button all the time

        this.recorderTimer=null;
        this.maxBufferSeconds=120;//1200 seconds = 20 minutes
        // this.maxBufferSeconds=120;
        this.currentTimerSecond=0;
        this.downloadOnDataAvailable=false;
        this.currentRecordingPartition=1;
        this.streamService=new KinoStreamService('record');
        this.streamService.getServers();
        this.rec_session_id=null;
        this.recordingFiles=[];
        this.durationChunks=[];
        window.simulateDisconnect=()=>{
            this.streamService.resumeOnConnect=true;
            this.streamService.socket.emit('close-socket','msg');
            setTimeout(() => {
                this.streamService.resumeOnConnect=true;
                this.streamService.connectSocket();
            }, 1500);
        };

        this.willMergeVideos=false;

        this.recorderListPopulated = false
    }

    async events() {
        // console.error(await electronConfig())
        let rec = this;
        axios.post(convertPath('/addon/kino-recorder'),{},await electronConfig()).then((response) =>{
            // console.warn(response.data);
            if(response && response.data && response.data.available){
                rec.hasRecordingAvailability = response.data.available;
            }
        }).catch((err) =>{
            console.error(err);
        })

        $(window).on('beforeunload' ,e=>rec.unload());
        if(isElectron){
            api.global.recieve('download-finished',rec.onDownloadFinished.bind(rec));
        }
        socket.events.startedRecording = rec.startedRecording.bind(rec);
        socket.events.stoppedRecording = rec.stoppedRecording.bind(rec);

        $(document).on(
            'mouseover mousemove',
            '#recorder-indicator',function (e) {rec.isRecordingList.call(rec);});

    }

    startRecDuration(){
        this.recLastStart=moment();
        this.startDurationInterval();
    };

    pauseRecDuration(){
        try {
            this.durationChunks.push({start:this.recLastStart,end:moment()});
            this.recLastStart=null;
            this.stopDurationInterval();
        } catch (error) {

        }
    };

    countDuration(){
        let totalMS=0;
        this.durationChunks.forEach(chunk=>{
            let duration = moment.duration(chunk.end.diff(chunk.start));
            totalMS+=duration.asMilliseconds();
        });
        //count current chunk
        if(this.recLastStart){
            let duration = moment.duration(moment().diff(this.recLastStart));
            totalMS+=duration.asMilliseconds();
        }
        return totalMS;
    };

    updateRecDurationTime(){
        let rec = this;
        let durMS=this.countDuration();
        let durationTime=moment.utc(durMS).format('HH:mm:ss');
        rec.updateDurationContainer(durationTime);
    };

    startDurationInterval(){
        clearInterval(this.durationInterval)
        this.durationInterval=setInterval(this.updateRecDurationTime.bind(this),1000);
    }

    updateDurationContainer(time){
        let rec = this;
        rec.timerHours.html(moment(time, 'HH:mm:ss').format('HH'));
        rec.timerMinutes.html(moment(time, 'HH:mm:ss').format('mm'));
        rec.timerSeconds.html(moment(time, 'HH:mm:ss').format('ss'));
    }

    resetDurationContainer(){
        let rec = this;
        rec.timerHours.html('00');
        rec.timerMinutes.html('00');
        rec.timerSeconds.html('00');
    }

    stopDurationInterval(){
        let rec = this;
        clearInterval(rec.durationInterval);
    }

    resetDurationTime(){
        let rec = this;
        rec.resetDurationContainer();
        rec.durationChunks = [];
    }

    isModerator(){
        return ROLE == "moderator" || HOST==1;
    };
    onDownloadFinished(data){
        let res=data[0];
        let tooltip = new kinoTooltip("recorder-menu","Recording saved in Downloads folder", {left: '20px', bottom: '150%', width:'250px'});
            tooltip.addTooltip();
            setTimeout(() => {
                tooltip.hideTooltip()
        }, 5000);
    };

    addOptionButton() {
        var rec = this;
        // if (rec.btn !== null || !room.isModerator()) {
        //     return
        // }
        let optionIcon = $('<div/>', {
            class: "option-icon",
            html: rec.kinoRecorderSvg,
        });
        let optionName = $('<div/>', {
            class: "option-name",
            html: rec.btnLabel,
        });
        let optionAction = $('<div/>', {
            class: "option-action",
            html: '',
        });
        let optionDescription = $('<div/>', {
            class: "option-description",
            html: [ optionName, optionAction],
        });
        let optionsBtn = $('<div/>', {
            class: `option ${(!permissions.hasKinoRecorder() || !rec.hasRecordingAvailability) ? 'feature-disabled' : ''}`,
            id: 'kinoRecordingBtn',
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            'data-original-title': '',
            html: [optionIcon, optionDescription],
        }).on('click',()=>{
            if(this.disabled || !this.hasRecordingAvailability || !permissions.hasKinoRecorder()){
                return;
            }
            //this.startNewTimer();
            // rec.renderModal();
            if(permissions.hasKinoRecorder()){
                hideSideMenu();
                if(isElectron){
                    let os= api.global.sendSync('os');
                    if(os=="darwin"){
                        $("#alertModal").modal('show');
                        $("#alertModalBody").html('Please use Google Chrome to use the Kino Recorder on Mac OS');
                        // console.log('O System == darwin: '+ os);
                        return;
                    }
                }
                // if(res.isAvailable){
                //     res.renderRecordingNotAvailable();
                //     return;
                // }
                rec.addRecodingControls();
            }
            // rec.noPermissionsToRecord();
        }).on('mouseenter',()=>{
            if(!permissions.hasKinoRecorder()){
                if(permissions.isWorkspace){

                    if(optionsBtn.attr('data-original-title') == `This feature is disabled in this workspace.`)return
                    optionsBtn.attr('data-original-title', `This feature is disabled in this workspace.`)
                    return
                }else{
                    if(optionsBtn.attr('data-original-title') == rec.mustHaveModerator)return
                    optionsBtn.attr('data-original-title', rec.mustHaveModerator)
                    return
                }
            }else if(!rec.hasRecordingAvailability){
                optionsBtn.attr('data-original-title',`${rec.btnLabel} add-on not available.`)
            }else if(!rec.disabled){
                optionsBtn.attr('data-original-title', '')
            }
        });

        rec.optionList.find("#kinoRecordingBtn").remove();
        rec.optionList.append(optionsBtn);
    };

    //Add the kino controls container
    addRecodingControls(){
        let rec = this;
        if(!this.hasRecordingAvailability || !permissions.hasKinoRecorder()){
            return
        }
        rec.forceStopped = false;

        if(rec.recorderControlContainer){
            rec.removeRecordingAccess()
            return;
        }

        rec.controlPlaybackIcon = $('<div/>',{
            class: 'kinetx-icon',
            html: rec.isRecording ? rec.isPaused ? rec.resumeSvg : rec.pauseSvg : rec.startSvg,
        });
        rec.controlPlayback = $('<button/>',{
            class: 'recorder-buttons',
            id: 'start-recording',
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            'data-original-title': rec.isRecording ? rec.isPaused ? 'Resume Recording' : 'Pause Recording' : 'Start Recording',
            html: rec.controlPlaybackIcon
        }).on('click', function(){
            if(buttonSpam.isSpam($(this).attr('id'))){
                return;
            }
            rec.startRecording();
        });



        rec.stopRecordingIcon = $('<div/>',{
            class: 'kinetx-icon',
            html: rec.stopSvg,
        })
        rec.stopRecording = $('<button/>',{
            class: 'recorder-buttons',
            id: 'stop-recording',
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            'data-original-title': 'Stop Recording',
            html: rec.stopRecordingIcon
        }).on('click', function(){
            if(buttonSpam.isSpam($(this).attr('id'))){
                return;
            }
            rec.stopCapture();
        });

        rec.recorderButtonContainer = $("<div/>", {
            class: "recorder-buttons-container",
            html: [rec.controlPlayback, rec.stopRecording]
        })

        let closeControls = $('<span/>',{
            class: 'close-recording-controls',
            html: rec.closeControlsIcon,
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            'data-original-title': 'Close Kino recorder controls',
        }).on('click', ()=>{
            rec.recorderControls.remove();
            rec.recorderControls = null;
        });

        rec.timerHours = $('<span/>',{
            html: '00'
        })

        rec.timerMinutes = $('<span/>',{
            html: '00'
        })

        rec.timerSeconds = $('<span/>',{
            html: '00'
        })

        let timerFields = $('<div/>',{
            class: 'd-flex kino-timer-time-container',
            html: [rec.timerHours, ':', rec.timerMinutes, ':', rec.timerSeconds]
        })

        let timerContainer = $('<div/>',{
            class: 'kino-recorder-timer',
            html: [timerFields]
        })

        rec.removeRecorder=$("<span/>", {
            class:`remove-recorder-btn ${!permissions.hasKinoRecorder() && "d-none"}`,
            html:`<svg class="remove-option-icon" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 45.334 45.334" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M43.576 35.092 31.152 22.668l12.424-12.424a6 6 0 0 0-8.485-8.485L22.666 14.183 10.242 1.758a6 6 0 0 0-8.485 8.485l12.425 12.424L1.757 35.091a6 6 0 1 0 8.486 8.485l12.423-12.423 12.425 12.424c1.173 1.171 2.707 1.757 4.243 1.757s3.071-.586 4.243-1.757a6 6 0 0 0-.001-8.485z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg>`
            }).on("click", function(){
                $(".tool-buttons-right").append($("#recorder-indicator"))
                rec.removeRecordingAccess()
            })

        rec.recorderControls = $('<div/>',{
            class: 'btn-group recorder-menu',
            id: 'recorder-menu',
            html: [timerContainer, rec.recorderButtonContainer,rec.removeRecorder]
        }).on('click', function(){

        });

        rec.recorderControlContainer = $("<div/>", {
            class: "recorder-control-conatiner border-class border-right-white",
            html: rec.recorderControls
        })

        rec.updateRecDurationTime();
        $(".toolbox-announcement").removeClass("border-right-white")
        $('.strip-options-content').prepend(rec.recorderControlContainer)
    }

    removeRecordingAccess(){
        let rec = this;
        rec.forceStopped = true;
        if(rec.isRecording){
            rec.stopCapture();
        }
        if(rec.recorderControlContainer){
            rec.recorderControlContainer.remove();
            rec.recorderControlContainer = null;
        }
    }

    showTipModal(){
        let rec = this;

        let tipModalFooterCancel = $('<button/>',{
            class: 'btn kino-btn-secondary',
            type: 'button',
            'data-dismiss': 'modal',
            html: 'Cancel'
        });

        let tipModalFooterOk = $('<button/>',{
            class: 'btn kino-btn-primary',
            id: 'modalStartRecBtn',
            html: 'Start Recording'
        }).on('click', function(){
            rec.modalAccepted = true;
            rec.startRecording();
        });

        let tipModalFooter = $('<div/>',{
            class: 'modal-footer',
            html: [tipModalFooterCancel, tipModalFooterOk]
        });

        let tipModalBodyHeader = $('<p/>',{
           class: 'text-center',
           id: 'kino-recorder-text-1',
           html: rec.modalBodyHeaderText
        });

        let tipModalImage = $('<img/>',{
            class: 'photoShadow',
            src: rec.tipImage
        });

        let tipModalBodySubHeader = $('<p/>',{
            class: 'font-weight-bold text-center',
            id: 'kino-recorder-text-2',
            html: rec.modalBodySubHeaderText
        });

        let tipModalBodyBottomText = $('<p/>',{
            class: 'font-weight-bold text-center',
            id: 'kino-recorder-text-3',
            html: `<u>${rec.modalBodyBottomText}</u>`
        });

        this.errorMessageSpan = $('<span/>',{
            class: 'error_kino',
            html: ''
        });

        let errorMessageContainer = $('<div/>',{
            class: 'd-flex justify-content-center align-items-center',
            html: this.errorMessageSpan
        });

        let tipModalBodyWrapper = $('<div/>',{
            class: 'px-1 kino-recorder-modal-body',
            html: [tipModalBodyHeader, tipModalImage, tipModalBodySubHeader, tipModalBodyBottomText, errorMessageContainer]
        });

        let tipModalSubTitle = $('<span/>',{
            class: '',
            id: 'modal-subheader',
            html: rec.modalSubHeader
        });

        let tipModalBody = $('<div/>',{
            class: 'modal-body pt-0',
            html: [tipModalSubTitle,tipModalBodyWrapper]
        });

        let tipModalTitle = $('<h4/>',{
            class: 'modal-title text-center mb-2',
            id: '',
            html: rec.modalTitle
        });

        let tipCloseModalBtn = $('<button/>',{
            class: 'close-button-modal-kino',
            type: 'button',
            'data-dismiss': 'modal',
            'aria-label': 'Close',
            html: rec.closeModalBtn
        });

        let tipModalHeader = $('<div/>',{
            class: 'modal-header modal-header-kino pb-0',
            html: [tipModalTitle, tipCloseModalBtn]
        });

        let tipModalContent = $('<div/>',{
            class: 'modal-content',
            html: [tipModalHeader, tipModalBody, tipModalFooter]
        });

        let tipModalWrapper = $('<div/>',{
            class: 'modal-dialog',
            role: 'document',
            style: '',
            html: [tipModalContent]
        });

        rec.tipModal = $('<div/>',{
            class: 'modal modal-inside-kino fade',
            id: 'start-recording-modal',
            tabindex: '-1',
            role: 'dialog',
            'aria-labelledby': 'start-recording-modal-modalCenterTitle',
            'aria-hidden': 'true',
            'data-keyboard': 'false',
            'data-backdrop': 'static',
            html: [tipModalWrapper]
        });

        rec.tipModal.modal();
    }

    showAdModal(){
        let rec = this;

        let tipModalFooterCancel = $('<button/>',{
            class: 'btn kino-btn-secondary',
            type: 'button',
            'data-dismiss': 'modal',
            html: 'Cancel'
        });

        // let tipModalFooterOk = $('<button/>',{
        //     class: 'btn kino-btn-primary',
        //     id: 'modalStartRecBtn',
        //     html: 'Start Recording'
        // }).on('click', function(){
        //     rec.modalAccepted = true;
        //     rec.startRecording();
        // });

        let tipModalFooter = $('<div/>',{
            class: 'modal-footer border-0 pt-0',
            html: [tipModalFooterCancel]
        });

        let tipModalBodyHeader = $('<p/>',{
           class: 'text-center mt-2',
           id: 'kino-recorder-text-1',
           html: `You might not be able to download the recording if an ad-blocker is active, please disable any ad-blocker before recording.`
        });

        let tipModalBodySubHeader = $('<h3/>',{
            class: 'mt-2 text-center',
            id: 'kino-recorder-text-2',
            html: `Ad Blocker detected`
        });

        // let tipModalBodyBottomText = $('<p/>',{
        //     class: 'font-weight-bold text-center',
        //     id: 'kino-recorder-text-3',
        //     html: `<u>${rec.modalBodyBottomText}</u>`
        // });

        let tipModalBodyWrapper = $('<div/>',{
            class: 'px-1 kino-recorder-modal-body',
            html: [`<svg role="img" width="80px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path fill="#c51a05" d="M7.775 0a1.8 1.8 0 0 0-1.273.527L.528 6.503A1.8 1.8 0 0 0 0 7.775v8.45c0 .478.19.936.528 1.274l5.974 5.974A1.8 1.8 0 0 0 7.775 24h8.45a1.8 1.8 0 0 0 1.273-.527l5.975-5.974A1.8 1.8 0 0 0 24 16.225v-8.45a1.8 1.8 0 0 0-.527-1.272L17.498.527A1.8 1.8 0 0 0 16.225 0zm4.427 3c1.02 0 .958 1.108.958 1.108v6.784s-.009.218.16.218c.188 0 .175-.226.175-.226l-.002-5.63s-.05-.986.959-.986c1.01 0 .97.983.97.983v7.621s.014.158.141.158c.127 0 .944-2.122.944-2.122s.451-1.497 2.576-1.1c.038.008-.167.688-.167.688l-2.283 6.556S15.69 20.7 11.714 20.7c-5.044 0-4.808-5.407-4.814-5.405V7.562s-.016-.99.897-.99c.858 0 .849.99.849.99l.007 3.583s-.004.172.167.172c.16 0 .141-.172.141-.172l.01-5.926s-.055-1.162.966-1.162c1.04 0 .983 1.142.983 1.142v5.611s-.005.204.152.204c.168 0 .154-.206.154-.206l.01-6.693S11.18 3 12.202 3Z"/>
            </svg>`,tipModalBodySubHeader,tipModalBodyHeader]
        })

        let tipModalBody = $('<div/>',{
            class: 'modal-body pt-0',
            html: [tipModalBodyWrapper]
        });

        let tipModalTitle = $('<h4/>',{
            class: 'modal-title text-center mb-2',
            id: '',
            html: rec.modalTitle
        });

        // let tipModalSubTitle = $('<span/>',{
        //     class: '',
        //     id: '',
        //     html: rec.modalSubHeader
        // });

        let tipCloseModalBtn = $('<button/>',{
            class: 'close-button-modal-kino',
            type: 'button',
            'data-dismiss': 'modal',
            'aria-label': 'Close',
            html: rec.closeModalBtn
        });

        let tipModalHeader = $('<div/>',{
            class: 'modal-header modal-header-kino pb-0',
            html: [tipModalTitle, tipCloseModalBtn]
        });

        let tipModalContent = $('<div/>',{
            class: 'modal-content',
            html: [tipModalHeader, tipModalBody, tipModalFooter]
        });

        let tipModalWrapper = $('<div/>',{
            class: 'modal-dialog',
            role: 'document',
            style: '',
            html: [tipModalContent]
        });

        rec.adModal = $('<div/>',{
            class: 'modal modal-inside-kino fade',
            id: 'start-recording-adBlocker-modal',
            tabindex: '-1',
            role: 'dialog',
            'aria-labelledby': 'start-recording-adBlocker-modal-modalCenterTitle',
            'aria-hidden': 'true',
            'data-keyboard': 'false',
            'data-backdrop': 'static',
            html: [tipModalWrapper]
        });

        rec.adModal.modal();
    };

    renderRecordingNotAvailable(){

    }

    /**
    * Mixes multiple audio tracks and the first video track it finds
    * */
    mixer(stream1, stream2) {
        const ctx = new AudioContext();
        const dest = ctx.createMediaStreamDestination();

        if (stream1.getAudioTracks().length > 0){
            ctx.createMediaStreamSource(stream1).connect(dest);
        }

        if (stream2.getAudioTracks().length > 0){
            ctx.createMediaStreamSource(stream2).connect(dest);
        }

        let tracks = dest.stream.getTracks();
        tracks = tracks.concat(stream1.getVideoTracks()).concat(stream2.getVideoTracks());

        return new MediaStream(tracks)

    }

    /**
    * Returns a filename based o room name in the URL and timestamp
    * */
    getFilename() {
        const now = new Date();
        const timestamp = now.toISOString();
        const room = location.pathname.split("/");
        if (ROOM_NAME)
            return `Kino_${ROOM_NAME}_${timestamp}`;
        else
            return `recording_${timestamp}`;
    }

    async startRecording() {
        let rec = this;
        if(this.disabled || !permissions.hasKinoRecorder()){
            return;
        }
        rec.forceStopped = false;
        if (rec.isRecording) {
            rec.pauseRecording();
            return;
        }
        if (!rec.modalAccepted && !isElectron) {
            if(isAdBlockActive){
                rec.showAdModal();
            }else{
                rec.showTipModal();
            }

            return;
        }
        rec.tipModal && rec.tipModal.modal('hide');

        if(isAdBlockActive){
            rec.showAdModal();
            return;
        }
        rec.disableLiveStream();
        rec.recordingData = [];
        let source_id= isElectron ? api.global.sendSync('window:source_id') : null;
                /*let source_id = await api.global.getdesktopSources().then(res => {
            console.log('_record', res)
            return res.find(screen => screen.name.search('desktopCapturer') > -1 || screen.name.search('Kino Live') > -1)
        }).catch(err => {
            console.log('_record', err)
        })*/
        console.log('_record_source_id', source_id);
        if(isElectron){
            if(!source_id) {
                rec.enableLiveStream();
                return false;
            }
        }
        // source_id = source_id.id;
        // console.log('_record_source_id', source_id);

        if(isElectron){
            try {
                try {
                    let localAudio=room.getLocalAudioTrack();
                    if(localAudio){
                        console.log("got local audio");
                        this.gumStream=localAudio.stream;
                    }
                } catch (error) {
                    console.error('error getting local audio',error)
                }
                console.log('_record', this.gumStream)
                this.gdmStream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        mandatory: {
                            chromeMediaSource: 'desktop',
                            chromeMediaSourceId: source_id
                        }
                    },
                    audio: {
                        mandatory: {
                            chromeMediaSource: 'desktop',
                            chromeMediaSourceId: source_id,
                            echoCancellation: false
                        }
                    }
                });
                console.log('_record', this.gdmStream)
                const firstVideoTrack = this.gdmStream.getVideoTracks()[0];

               await firstVideoTrack.applyConstraints({
                   frameRate:{
                        max:rec.getFrameRate(),
                        ideal:rec.getFrameRate()
                    }
                    });
                let settings = firstVideoTrack.getConstraints();
                console.log("Desktop stream settings",settings);
            } catch (e) {
                console.error("capture failure", e);
                this.streamService.closeSocket();
                rec.enableLiveStream();
                return
            }
        }else{
            try {
                // this.gumStream = await navigator.mediaDevices.getUserMedia({
                //     video: false,
                //     audio: true
                // });
                try {
                    let localAudio=room.getLocalAudioTrack();
                    if(localAudio){
                        console.log("got local audio");
                        this.gumStream=localAudio.stream;
                    }
                } catch (error) {
                    console.error('error getting local audio',error)
                }

                this.gdmStream = await navigator.mediaDevices.getDisplayMedia({
                    video: {
                        displaySurface: "browser",
                        selfBrowserSurface: "include",
                        frameRate:{
                            max:rec.getFrameRate(),
                            ideal:rec.getFrameRate()
                        }
                    },
                    surfaceSwitching: "exclude",
                    preferCurrentTab: true,
                    audio: { channelCount: 2,echoCancellation:false}
                });
                if(!this.gdmStream.getAudioTracks().length){
                    this.gdmStream.stop();
                    this.showTipModal();
                    this.errorMessageSpan.addClass('mt-2').html('⚠ Please check <strong>Share Audio</strong> when selecting the streaming source.')
                    return;
                }
                try {
                    const firstVideoTrack = this.gdmStream.getVideoTracks()[0];

                    await firstVideoTrack.applyConstraints({
                            frameRate:{
                                max:rec.getFrameRate(),
                                ideal:rec.getFrameRate()
                            }
                        });
                    let settings = firstVideoTrack.getConstraints();
                    console.log("Desktop stream settings",settings);
                } catch (error) {

                }


            } catch (e) {
                console.error("capture failure", e);
                this.streamService.closeSocket();
                this.enableLiveStream();
                return
            }
        }
        //connect to socket
        this.willMergeVideos=false;
        try {
            if(this.streamService.socket && this.streamService.socket.connected){
                console.log("Found a conenction still open closing it");
                this.streamService.closeSocket();
            }
            this.streamService.generateSessionID();
            console.log("Waiting for connection..",this.streamService.socket);
            let connected=await this.streamService.socketStartStream({type:"record",kino_id:ROOM_NAME,user_id:USER_ID});
            console.log("Was connection ok",connected);
            if(connected===false){
                this.gdmStream.getTracks().forEach(track => track.stop());
                this.serviceUnavailableModal();
                rec.enableLiveStream();
                return;
            }
        } catch (error) {
            this.gdmStream.getTracks().forEach(track => track.stop());
            console.error(error);
            this.serviceUnavailableModal();
            rec.enableLiveStream();
            return;
        }

        this.gdmStream.getVideoTracks()[0].onended = () => { // Click on browser UI stop sharing button
            console.info("Recording has ended");
            rec.stopCapture();
        };
        rec.recorderStream = this.gumStream ? rec.mixer(this.gumStream, this.gdmStream) : this.gdmStream;
        //console.log(recorderStream.getTracks());
        rec.startMediaRecorder();
        rec.recorderStream.addEventListener('inactive', () => {
            console.log('Capture stream inactive');
            rec.stopCapture();
        });
        rec.startRecordingTimer();
        console.log("started recording");
        rec.isRecording = true;
        rec.isPaused = false;
        // console.log(this.socket)
        room.setLocalParticipantProperty('kino_recording_status', JSON.stringify({
            value: 'recording',
            updated_at: moment.utc()
        }));
        socket.sendStartRecording(rec.startedRecordingMessage, rec.forceStopped);
        rec.startedRecording({
            data:{
                participant:"local",
                name:MY_NAME,
                message: rec.startedRecordingMessage,
                forced: rec.forceStopped
            }
        },true);
        //window.postMessage({ type: "FROM_KINO", text: "Started Recording" }, "*");
        rec.switchButtonUI("stop");

    }

    startMediaRecorder(asPaused=false,startTimer=true){
        let rec=this;
        var options;
            if(MediaRecorder.isTypeSupported('video/webm;codecs=h264')){
                options = {mimeType: 'video/webm;codecs=h264'};
            }else if (MediaRecorder.isTypeSupported('video/webm;codecs=vp9')) {
                options = {mimeType: 'video/webm;codecs=vp9'};
            } else {
                options = {mimeType: 'video/webm; codecs=vp8,opus'};
            }
        console.log("Selected codec",options)
        rec.recorder = new MediaRecorder(rec.recorderStream,options);
        rec.recordingData=[];
        rec.endedToBeResumed=false;
        rec.recorder.ondataavailable = e => {
            // console.log("data available size ",((e.data.size)/1024)/1024);
            if (e.data && e.data.size > 0) {
                // rec.recordingData.push(e.data);
                rec.streamService.sendData(e.data);
            }
        };

        rec.recorder.addEventListener('stop', (e) => {
            if(this.endedToBeResumed){return}
            this.enableLiveStream();
            rec.pauseRecDuration();
            console.log("Recorder on stop event");
            if (!rec.isRecording) {
                rec.stopRecordingTimer();
                // rec.download();
                rec.recorderStream.getTracks().forEach(track => track.stop());
                rec.gdmStream.getTracks().forEach(track => track.stop());
            }else if(rec.downloadOnDataAvailable && rec.isRecording){
                // rec.download(rec.currentRecordingPartition,rec.recordingData);
                rec.currentRecordingPartition++;
                rec.recordingData=[];
                rec.downloadOnDataAvailable=false;
                rec.startMediaRecorder();
            }else{
                rec.stopRecordingTimer();
                rec.recorderStream.getTracks().forEach(track => track.stop());
                rec.gdmStream.getTracks().forEach(track => track.stop());
            }
            // gumStream.getTracks().forEach(track => track.stop());
            rec.streamService.endRecording();
        });
        rec.recorder.start(200);
        if(asPaused){
            rec.recorder.pause();
        }else{
            startTimer && rec.startRecDuration();
        }
    };
    switchButtonUI(mode) {
        var rec = this;
        // console.log(mode);
        if (mode == "start") {
            rec.controlPlayback.find(".kinetx-icon").html(rec.startSvg);
            rec.controlPlayback.attr({'data-original-title': 'Start Recording',title: 'Start Recording'});
            rec.controlPlayback.tooltip('hide');
            return;
        }
        if (mode == "resume") {
            //changed stroke from red to white
            rec.controlPlayback.find(".kinetx-icon").html(rec.resumeSvg);
            rec.controlPlayback.attr({'data-original-title': 'Resume Recording',title: 'Resume Recording'});
            rec.controlPlayback.tooltip('hide');
            return;
        }
        if (mode == "stop") {
            rec.controlPlayback.find(".kinetx-icon").html(rec.pauseSvg);
            rec.controlPlayback.attr({'data-original-title': 'Pause Recording',title: 'Pause Recording'});
            rec.controlPlayback.tooltip('hide');
            return;
        }
    };

    /**
    * Stop recording
    * */
    stopCapture(isHangup=false) {
        let rec = this;
        let stopRecordingMessage = rec.forceStopped ? rec.forceStoppedRecordingMessage : rec.stoppedRecordingMessage;
        let forced = rec.forceStopped;
        rec.stopRecordingTimer();
        rec.enableLiveStream();
        rec.downloadOnDataAvailable=false;
        rec.endedToBeResumed=false;
        // console.log("Stopping recording", rec.forceStopped);
        // console.log('stop capture: ',rec.recorder.state);
        if (rec.recorder.state !== 'inactive') {
            rec.recorder.stop();
            if(isHangup){
                try {
                    this.streamService.closeSocket();
                } catch (error) {

                }
            }
        }
        if (rec.isRecording && !rec.isPaused) {
            room.setLocalParticipantProperty('kino_recording_status', JSON.stringify({
                value: 'stopped',
                updated_at: moment.utc()
            }));
            socket.sendStoppedRecording(stopRecordingMessage, forced);
            rec.stoppedRecording({
                data:{
                    participant:"local",
                    name:MY_NAME,
                    message: stopRecordingMessage,
                    forced: forced
                }
            },false);
        }
        rec.isRecording = false;
        rec.isPaused = false;
        rec.switchButtonUI("start");
        rec.resetDurationTime();
    }

    /**
    * Pause recording
    *
    */
    pauseRecording() {
        let rec = this;
        let forced = rec.forceStopped;
        if (rec.recorder.state === 'paused') {
            // console.log('pause recording: ',rec.recorder.state);
            rec.recorder.resume();
            rec.startRecDuration();
            rec.startRecordingTimer();

            rec.switchButtonUI("stop");
            rec.isPaused = false;
            room.setLocalParticipantProperty('kino_recording_status', JSON.stringify({
                value: 'resumed',
                updated_at: moment.utc()
            }));
            socket.sendStartRecording(rec.resumedRecordingMessage, forced);
            rec.startedRecording({
                data:{
                    participant:"local",
                    name:MY_NAME,
                    message: rec.resumedRecordingMessage,
                    forced: forced
                }
            },true);
        } else if (rec.recorder.state === 'recording') {
            rec.isPaused = true;
            rec.recorder.pause();
            rec.pauseRecDuration();
            clearInterval(this.recorderTimer);
            rec.recorder.requestData();
            rec.switchButtonUI("resume");
            room.setLocalParticipantProperty('kino_recording_status', JSON.stringify({
                value: 'paused',
                updated_at: moment.utc()
            }));
            socket.sendStoppedRecording(rec.pausedRecordingMessage, forced);
            rec.stoppedRecording({
                data:{
                    participant:"local",
                    name:MY_NAME,
                    message: rec.pausedRecordingMessage,
                    forced: forced
                }
            },false);
        } else {
            rec.stopCapture();
        }

        // console.log(`recorder ${rec.recorder.state === 'paused' ? "paused" : "recording"}`);
    };
    /**
    * Save recording
    */
    download(part=false,partData=[]) {
        let rec = this;
        var blob = new Blob(part ? partData : rec.recordingData, {
            type: "video/webm"
        });
        if(!part && rec.currentRecordingPartition > 1){
            part=rec.currentRecordingPartition;
        }
        getSeekableBlob(blob, (seekableBlob) => {
                // invokeSaveAsDialog(seekableBlob);
            var url = window.URL.createObjectURL(seekableBlob);
            let filename=`${rec.getFilename()}${part ? '-Part_'+ part : ''}.webm`;

                var a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = filename;

                document.body.appendChild(a);
                a.click();
                setTimeout(() => {
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                    // console.log(`${a.download} downloading file`);
                }, 100);
            if(!isElectron){
               setTimeout(()=>{
                    rec.onDownloadFinished([{success:true}]);
               },1000);
            }

            $('#recorder-menu').removeClass("visible");
        });
    }

    startRecordingTimer(){
        this.recorderTimer=setInterval(() => {
            this.currentTimerSecond++;
            if(this.currentTimerSecond==this.maxBufferSeconds){
                this.requestRecorderData();
            }
        }, 1000);
    };
    requestRecorderData(){
        // this.downloadOnDataAvailable=true;
        // this.currentTimerSecond=0;
        // this.recorder.stop();
        // this.streamService.endRecording();
        // this.streamService.resumeStream();
    };
    stopRecordingTimer(){
        clearInterval(this.recorderTimer);
        this.downloadOnDataAvailable=false;
        this.currentRecordingPartition=1;
        this.currentTimerSecond=0;
    }
    unload(){
        let rec = this;
        if(rec.isRecording){
            rec.stopCapture();
        }
    }

     /**
     * Local recording event handler functions
     * commented for production
     */

    startedRecording (request,notification=true) {
    var rec = this;
    rec.forceStopped = request.data.forced;

    $(".recorder-control-conatiner").append($("#recorder-indicator"))
    rec.isRecordingListVisible()
    $("#recorder-indicator").addClass("recordingOn");
    $("#recorder-indicator").addClass("moderator");
    $("#recorcingID").addClass("d-none")

    Video.notifications.find(`.recording-notification-${request.data.participant}`).remove();
    if (Video.videos[request.data.participant] !== undefined) {
        // console.log(request);
        Video.videos[request.data.participant].recordingIndicator.addClass('recordingOn');
        if(notification)
        Video.showNotification('', `${request.data.name} ${request.data.message}`, 'recording',request.data.participant);
    }else if (request.data.participant == 'local'){
        Video.showNotification('', `You ${request.data.message}`, 'recording',request.data.participant);
    }
        rec.recordedBy[request.data.participant] = {
            id: request.data.participant,
            name: request.data.name,
            started: new Date()
        };
    }
    stoppedRecording (request,notification=true) {
        var rec = this;
        rec.forceStopped = request.data.forced;
        delete rec.recordedBy[request.data.participant];
        Video.notifications.find(`.recording-notification-${request.data.participant}`).remove();
        if (Video.videos[request.data.participant] !== undefined) {
            Video.videos[request.data.participant].recordingIndicator.removeClass('recordingOn');
            if(notification)
            Video.showNotification('', `${request.data.name} ${request.data.message}`, 'recording',request.data.participant);
        }else if (request.data.participant == 'local'){
            // Video.showNotification('', `${request.data.forced ? 'Your' : 'You'} ${request.data.message}`, 'recording',request.data.participant);
            if(request.data.message === rec.pausedRecordingMessage) {
                Video.showNotification('', `${request.data.forced ? 'Your' : 'You'} ${request.data.message}`, 'recording',request.data.participant);
            } else if(rec.willMergeVideos) {
                Video.showNotification('', `The recording is being processed and will be ready for download soon. Recordings can also be downloaded from the Kino account page.`, 'recording-merge',request.data.participant);
            } else {
                Video.showNotification('', `Recording has stopped and is being processed. A download notification will show soon.`, 'recording',request.data.participant);
            }
        }
        if (Object.keys(rec.recordedBy).length == 0) {
            $("#recorder-indicator").removeClass("recordingOn");
            rec.whoIsRecording.removeClass('shown');
            rec.whoIsRecording.html('');
            $("#recorder-wraper").addClass("d-none")
        }
    }

    isRecordingList () {
        let rec = this;

        // console.log(rec.whoIsRecording.hasClass('shown'))
        if (rec.whoIsRecording.hasClass('shown')) {
            clearTimeout(rec.recordingListTimeout);
            rec.recordingListTimeout = setTimeout(() => {
                rec.hideRecordingList();
            }, 5000);
            return;

        }
        let newlist = []
        rec.whoIsRecording.addClass('shown');
        $.each(rec.recordedBy, function (i, user) {
            newlist.push(user)
        });
        if(newlist.length > 1){
            let recorders = "<span><b>Recording by:</b></span>"
            newlist.map((item) => {
                recorders += `<span>${item.name}</span>`
            })
            rec.whoIsRecording.html(recorders);
        }else {
            let recorders = ""
            newlist.map((item) => {
                recorders += `<span>${item.name} is recording</span>`
            })
            rec.whoIsRecording.html(recorders);
        }
        clearTimeout(rec.recordingListTimeout);
        rec.recordingListTimeout = setTimeout(() => {
            rec.hideRecordingList();
        }, 5000);
    };

    isRecordingListVisible(){
        if($("#recorder-menu").is(":visible")){
            $("#recorder-wraper").remove()
            return
        }
        let rec = this;

        let newlist = [];
        let recorders = ""
        $.each(rec.recordedBy, function (i, user) {
            newlist.push(user)
        });

        newlist.map((item) =>
            recorders += `<span>${item.name} is recording</span>`
        )
        $(".whoRecordinVisible").html(" ")
        if(newlist.length > 1){
            $(".whoRecordinVisible").append(`<b>${newlist.length} Participants<b/> use Kino Recorder`)
        }else {
            $(".whoRecordinVisible").append(recorders)
        }
    }

    hideRecordingList () {
        let rec = this;
        rec.whoIsRecording.removeClass('shown');
        rec.whoIsRecording.html('');
        clearTimeout(rec.recordingListTimeout);
    };
    /**
     *END:Local recording event handler functions
     */

        /**
     * User join event
     */

    showRecorderInControlStrip () {
        $("#recorder-indicator").removeClass("moderator");
        $("#recorder-wraper").removeClass("moderator");
        $("#recorder-wraper").removeClass("d-none")
        $("#recorder-indicator").addClass("recording-flex-1");
        $("#stripOptionsContent").append($("#recorder-wraper"))
        if(permissions.isMod()){
            $("#recorder-wraper").addClass("moderator-recorder")
        }else {
            $("#recorder-wraper").removeClass("moderator-recorder")
        }
    }

    recordingStatusChanged(user, value) {
        let rec = this;
        console.log("property_changed", user)
        console.log("property_changed", value)
        console.log("property_changed", Math.abs(moment.duration(moment(value.updated_at).diff(moment.utc())).asSeconds()) )
        if(value) {
            value = JSON.parse(value)
            if((value.value == "recording" || value.value == "resumed")) {
                $("#recorder-indicator").addClass("recordingOn");
                if(permissions.hasKinoRecorder()){
                    rec.showRecorderInControlStrip()
                    $("#recorder-indicator").addClass("moderator");
                }else {
                    $("#recorcingID").removeClass("d-none")
                    rec.showRecorderInControlStrip()
                }
                rec.recordedBy[user.getId()] = {
                    id: user.getId(),
                    name: user.getDisplayName(),
                    started: new Date()
                }
                Video.notifications.find(`.recording-notification-${user.getId()}`).remove();

                if (Video.videos[user.getId()] !== undefined) {
                    Video.videos[user.getId()].recordingIndicator.addClass('recordingOn');
                    if(Math.abs(moment.duration(moment(value.updated_at).diff(moment.utc())).asSeconds()) < 3){
                        // I already joined
                        Video.showNotification('', `${user.getDisplayName()} ${(value.value == "recording") ? rec.startedRecordingMessage : rec.resumedRecordingMessage}`, 'recording',user.getId());
                    }else {
                        //  I just joined
                        Video.showNotification('', `${user.getDisplayName()} ${rec.isRecordingMessage}`, 'recording',user.getId());
                    }
                }
            }
            // } else if((value.value == "recording" || value.value == "resumed") && Math.abs(moment.duration(moment(value.updated_at).diff(moment.utc())).asSeconds()) > 3 ) {
            //     $("#recorder-indicator").addClass("recordingOn");
            //     $("#recorder-indicator").removeClass("moderator");
            //     $("#recorder-wraper").removeClass("moderator");
            //     $("#recorder-wraper").removeClass("d-none")
            //     $("#recorcingID").removeClass("d-none")
            //     $("#recorder-indicator").addClass("recording-flex-1");
            //     $("#stripOptionsContent").append($("#recorder-wraper"))
            //     rec.isRecordingListVisible()
            //     rec.recordedBy[user.getId()] = {
            //         id: user.getId(),
            //         name: user.getDisplayName(),
            //         started: new Date()
            //     }
            //     Video.notifications.find(`.recording-notification-${user.getId()}`).remove();
            //     if (Video.videos[user.getId()] !== undefined) {
            //         Video.videos[user.getId()].recordingIndicator.addClass('recordingOn');
            //         Video.showNotification('', `${user.getDisplayName()} ${rec.isRecordingMessage}`, 'recording',user.getId());
            //     }
            // }
            else if((value.value == "stopped") && Math.abs(moment.duration(moment(value.updated_at).diff(moment.utc())).asSeconds()) < 3 ) {
                let stopRecordingMessage = rec.forceStopped ? rec.forceStoppedRecordingMessage : rec.stoppedRecordingMessage;
                Video.notifications.find(`.recording-notification-${user.getId()}`).remove();               //card id 541
                Video.showNotification('', `${user.getDisplayName()} ${stopRecordingMessage}`, 'recording',user.getId());
                Video.videos[user.getId()].recordingIndicator.removeClass('recordingOn');
                delete rec.recordedBy[user.getId()]
                if (Object.keys(rec.recordedBy).length == 0) {
                    $("#recorder-indicator").removeClass("recordingOn");
                    $("#recorder-indicator").addClass("recording-flex-1");
                    $("#whoRecordingList").removeClass('shown');
                    $("#whoRecordingList").html('');
                    $("#recorder-wraper").addClass("d-none")
                }
            } else if((value.value == "paused") && Math.abs(moment.duration(moment(value.updated_at).diff(moment.utc())).asSeconds()) < 3 ) {
                Video.notifications.find(`.recording-notification-${user.getId()}`).remove();               //card id 541
                Video.showNotification('', `${user.getDisplayName()} ${rec.pausedRecordingMessage}`, 'recording',user.getId());
                Video.videos[user.getId()].recordingIndicator.removeClass('recordingOn');
                delete rec.recordedBy[user.getId()]
                if (Object.keys(rec.recordedBy).length == 0) {
                    $("#recorder-indicator").removeClass("recordingOn");
                    $("#whoRecordingList").removeClass('shown');
                    $("#whoRecordingList").html('');
                    $("#recorder-wraper").addClass("d-none")
                }
            }
        }
        rec.isRecordingListVisible()
    }

    getFrameRate(){
        let framerate=15;
        if(navigator && navigator.hardwareConcurrency){
            if(navigator.hardwareConcurrency > 12){
                framerate=30;
            }else if(navigator.hardwareConcurrency <= 12 && navigator.hardwareConcurrency > 4){
                framerate=15;
            }else if(navigator.hardwareConcurrency <= 4){
                framerate=10;
            }
        }
        return framerate;
    };

    onSocketDisconnected(){
        if (this.recorder && this.recorder.state !== 'inactive'){
            this.endedToBeResumed=true;
            this.recorder.stop();
            // this.onReadyForDownload(this.streamService.currentFilename);
        }
    };

    onSocketReconnected(resume){
        if(resume && this.isRecording){
            this.streamService.resumeStream().then(()=>{
                this.willMergeVideos=true;
                this.startMediaRecorder(this.isPaused,false);
            });
        }
    };

    // onRecordingMerge(info){
    //         // MODAL
    //         let profile = 'https://kino.live/profile';
    //         let rec = this;
    //         if(rec.mergeProcessModal){rec.removeModal(rec.mergeProcessModal)}

    //         let readyDownloadSvg = $("<div/>", {
    //             class: 'ready-download-svg-container',
    //             type: "button",
    //             // href: "#",
    //             // target: "_blank",
    //             html: rec.downloadReadySvg
    //         }).on('click', (e)=>{
    //             startDownloadBtn.trigger('click');
    //         });

    //         let readyDownloadIcon = $("<div/>", {
    //             class: 'ready-download-icon',
    //             html: readyDownloadSvg
    //         });

    //         let readyDownloadText = $("<div/>", {
    //             class: 'ignore-drag ready-download-text',
    //             // html: 'Recordings are available for 24 hours to download on profile'
    //             html:`The recording can also be downloaded from the Kino account page at a later time.`
    //         });
    //         let errorText=$(`<div class="errors">
    //         <div class="alert mb-0 mt-2 pl-5 pr-5" style="padding: 0 !important;" role="alert">
    //             <div class="row align-items-center">
    //                 <div class="col-auto font-md pr-0 red-color">
    //                     <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 15.5H13V17.5H11V15.5ZM11 7.5H13V13.5H11V7.5ZM11.99 2.5C6.47 2.5 2 6.98 2 12.5C2 18.02 6.47 22.5 11.99 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 11.99 2.5ZM12 20.5C7.58 20.5 4 16.92 4 12.5C4 8.08 7.58 4.5 12 4.5C16.42 4.5 20 8.08 20 12.5C20 16.92 16.42 20.5 12 20.5Z" fill="#FF3D00"></path></svg>
    //                 </div>
    //                 <div class="col red-color px-2" style="font-size: 14px;">
    //                     <p class="m-0">The recording is not ready yet and is being processed. Please try again in a few minutes.</p>
    //                 </div>
    //             </div>
    //         </div>
    //         </div>`);

    //         let modalBody = $("<div/>", {
    //             class: 'modal-body mx-auto p-0 pl-3 pr-3',
    //             html: [readyDownloadIcon, readyDownloadText]
    //         });

    //         let minimizeModalBtn = $('<button/>',{
    //             class: "close-button-modal-kino minimize-button",
    //             type: "button",
    //             html: `<i class="fas fa-window-minimize"></i>`
    //         }).on('click', ()=>{
    //             Video.minimizedContent.minimizeModal('kinoDownloadProcessingMerge', rec.downloadReadySvgMinimize);
    //         });

    //         let closeModalBtn = $("<button/>", {
    //             class: "close-button-modal-kino",
    //             type: "button",
    //             html: `<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10"><path fill="#032836" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19
    //             0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34
    //             120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12
    //             3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12
    //             3.12-8.19 0-11.31L193.94 256z"></path>
    //         </svg>`
    //         }).on('click', e => {
    //             rec.removeModal(readyDownload);
    //         });

    //         let modalSubHeader = $("<span/>", {
    //             class: "ignore-drag",
    //             html: `Click the download button below to get the recording.`
    //             // html: 'Your recording is ready for download'
    //         });

    //         let modalHeader = $("<div/>", {
    //             class: "modal-header modal-header-kino",
    //             html: [`<h4 class="mt-2 mb-0 text-center ignore-drag" style="font-weight: 600;">Kino Recorder</h4>`, modalSubHeader, minimizeModalBtn, closeModalBtn]
    //         });

    //         let cancelDownloadBtn = $('<button/>',{
    //             class: "btn btn-primary kino-btn-secondary",
    //             type: "button",
    //             html: "close",
    //             'data-dismiss': "modal"
    //         })
    //         var a = document.createElement('a');
    //         a.style.display = 'none';
    //         a.href = "#";
    //         a.target = "_blank";

    //         let startDownloadBtn = $('<button/>', {
    //             class: "btn btn-primary kino-btn-primary",
    //             type: "button",
    //             html: 'Profile'
    //         }).on('click', function(e) {
    //            a.click();
    //            closeModalBtn.click();
    //         });


    //         let modalFooter = $("<div/>", {
    //             class: "modal-footer border-0",
    //             html: [cancelDownloadBtn, startDownloadBtn,a]
    //         });

    //         let modalContent = $("<div/>", {
    //             class: 'modal-content',
    //             html: [modalHeader, modalBody, modalFooter]
    //         });

    //         let modalDialog = $("<div/>", {
    //             class: "modal-dialog modal-dialog-centered",
    //             role: "document",
    //             html: modalContent
    //         });

    //         rec.mergeProcessModal = $("<div/>", {
    //             class: "modal fade",
    //             id: "kinoDownloadProcessingMerge",
    //             tabindex: "-1",
    //             role: "dialog",
    //             'aria-labelledby': "kinoDownloadProcessingMerge",
    //             'aria-hidden': "true",
    //             'data-backdrop': "static",
    //             'data-keyboard': "false",
    //             html: modalDialog
    //         }).on('keyup',function(e){
    //             if (e.keyCode == 27) {
    //                 rec.removeModal(rec.mergeProcessModal);
    //             }
    //         });

    //         $('body').append(rec.mergeProcessModal);
    //         rec.mergeProcessModal.modal('show');

    // };

    removeModal(modal) {
        let i = this;
        modal.modal("hide");
        setTimeout(() => {
            if(modal !== null){
                modal.remove();
            }
        }, 200);
    }
    sleep(seconds){
        return new Promise((resolve)=>{
            setTimeout(() => {
                resolve();
            }, seconds *1000);
        })
    };
    async onReadyForDownload(filename){
        let file=this.recordingFiles.find(f=>f.filename==filename);
        if(file){
            await this.sleep(2);
            // console.log("Recording status is ",await this.streamService.getRecordingStatus(file.filename));
            let recStatus = await this.streamService.getRecordingStatus(file.filename);
            // MODAL
            let profile = 'https://kino.live/profile';
            let rec = this;
            if(rec.readyDownload){rec.removeModal(rec.readyDownload)}

            let readyDownloadSvg = $("<div/>", {
                class: 'ready-download-svg-container',
                type: "button",
                // href: "#",
                // target: "_blank",
                html: rec.downloadReadySvg
            }).on('click', (e)=>{
                startDownloadBtn.trigger('click');
            });

            let readyDownloadIcon = $("<div/>", {
                class: 'ready-download-icon',
                html: readyDownloadSvg
            });

            let readyDownloadText = $("<div/>", {
                class: 'ignore-drag ready-download-text',
                // html: 'Recordings are available for 24 hours to download on profile'
                html:`The recording can also be downloaded from the Kino account page at a later time.`
            });
            let errorText=$(`<div class="errors">
            <div class="alert mb-0 mt-2 pl-5 pr-5" style="padding: 0 !important;" role="alert">
                <div class="row align-items-center">
                    <div class="col-auto font-md pr-0 red-color">
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 15.5H13V17.5H11V15.5ZM11 7.5H13V13.5H11V7.5ZM11.99 2.5C6.47 2.5 2 6.98 2 12.5C2 18.02 6.47 22.5 11.99 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 11.99 2.5ZM12 20.5C7.58 20.5 4 16.92 4 12.5C4 8.08 7.58 4.5 12 4.5C16.42 4.5 20 8.08 20 12.5C20 16.92 16.42 20.5 12 20.5Z" fill="#FF3D00"></path></svg>
                    </div>
                    <div class="col red-color px-2" style="font-size: 14px;">
                        <p class="m-0">The recording is not ready yet and is being processed. Please try again in a few minutes.</p>
                    </div>
                </div>
            </div>
        </div>`);
            var a = document.createElement('a');
            a.style.display = 'none';
            a.href = file.downloadUrl;
            a.target = "_blank";

            let modalSubHeader = $("<span/>", {
                class: "ignore-drag",
                id:"modal-subheader",
                html: `Click the download button below to get the recording.`
                // html: 'Your recording is ready for download'
            });

            let modalBody = $("<div/>", {
                class: 'modal-body mx-auto p-0 pl-3 pr-3',
                html: [modalSubHeader,readyDownloadIcon, readyDownloadText, a]
            });

            let minimizeModalBtn = $('<button/>',{
                class: "close-button-modal-kino minimize-button",
                type: "button",
                html: `<i class="fas fa-window-minimize"></i>`
            }).on('click', ()=>{
                Video.minimizedContent.minimizeModal('kinoDownloadReady', rec.downloadReadySvgMinimize);
            });

            let closeModalBtn = $("<button/>", {
                class: "close-button-modal-kino",
                type: "button",
                html: `<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10"><path fill="#032836" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19
                0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34
                120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12
                3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12
                3.12-8.19 0-11.31L193.94 256z"></path>
            </svg>`
            }).on('click', e => {
                rec.removeModal(readyDownload);
            });



            let modalHeader = $("<div/>", {
                class: "modal-header modal-header-kino",
                html: [`<h4 class="mt-2 mb-0 text-center ignore-drag" style="font-weight: 600;">Kino Recorder</h4>`, minimizeModalBtn, closeModalBtn]
            });

            let cancelDownloadBtn = $('<button/>',{
                class: "btn btn-primary kino-btn-secondary",
                type: "button",
                html: "close",
                'data-dismiss': "modal"
            })
            let startDownloadBtn = $('<button/>', {
                class: "btn btn-primary kino-btn-primary",
                type: "button",
                html: 'Download'
            }).on('click', function(e) {
                if(recStatus == 'ready'){
                    console.log('DOWNLOADING')
                    a.click();
                    // e.preventDefault();
                    // e.stopPropagation();
                    rec.removeModal(readyDownload);
                }
                else {
                    modalBody.append(errorText);
                }
            });


            let modalFooter = $("<div/>", {
                class: "modal-footer border-0",
                html: [cancelDownloadBtn, startDownloadBtn]
            });

            let modalContent = $("<div/>", {
                class: 'modal-content',
                html: [modalHeader, modalBody, modalFooter]
            });

            let modalDialog = $("<div/>", {
                class: "modal-dialog modal-dialog-centered",
                role: "document",
                html: modalContent
            });

            let readyDownload = $("<div/>", {
                class: "modal fade",
                id: "kinoDownloadReady",
                tabindex: "-1",
                role: "dialog",
                'aria-labelledby': "kinoDownloadReady",
                'aria-hidden': "true",
                'data-backdrop': "static",
                'data-keyboard': "false",
                html: modalDialog
            }).on('keyup',function(e){
                if (e.keyCode == 27) {
                    rec.removeModal(readyDownload);
                }
            });

            $('body').append(readyDownload);
            readyDownload.modal('show');
        }
    };

    onReconnectFailed(){
        if(this.isRecording){
            this.stopCapture();
        }
    };


    resumeRecordingModal(){
            // MODAL
            //commented for later
            // let profile = 'https://kino.live/profile';
            // let rec = this;
            // rec.resumeRecModal && rec.removeModal(rec.resumeRecModal);

            // let resumeRecordSvg = $("<a/>", {
            //     class: 'ready-download-svg-container',
            //     type: "button",
            //     href:`#`,
            //     target:'_blank',
            //     html: rec.kinoRecorderSvg
            // });

            // let resumeDownloadIcon = $("<div/>", {
            //     class: 'ready-download-icon',
            //     html: resumeRecordSvg
            // });

            // let readyDownloadText = $("<div/>", {
            //     class: 'ignore-drag ready-download-text',
            //     html: 'Recordings are available for 24 hours to download on profile'
            // });
            // let modalBody = $("<div/>", {
            //     class: 'modal-body mx-auto p-0',
            //     html: [resumeDownloadIcon, readyDownloadText]
            // });

            // let closeModalBtn = $("<button/>", {
            //     class: "close-button-modal-kino",
            //     type: "button",
            //     style: "font-size: 1.2rem; top: 8px;",
            //     html: `<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10"><path fill="gray" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19
            //     0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34
            //     120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12
            //     3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12
            //     3.12-8.19 0-11.31L193.94 256z"></path>
            // </svg>`
            // }).on('click', e => {
            //     rec.removeModal(rec.resumeRecModal);
            // });

            // let modalSubHeader = $("<span/>", {
            //     class: "ignore-drag",
            //     html: 'Resume recording'
            // });

            // let modalHeader = $("<div/>", {
            //     class: "modal-header modal-header-kino",
            //     html: [`<h4 class="mt-2 mb-0 text-center ignore-drag" style="font-weight: 600;">Kino Recorder</h4>`, modalSubHeader, closeModalBtn]
            // });

            // let cancelDownloadBtn = $('<button/>',{
            //     class: "btn btn-primary kino-btn-secondary",
            //     type: "button",
            //     html: "close",
            //     'data-dismiss': "modal"
            // })
            // let startDownloadBtn = $('<a/>', {
            //     class: "btn btn-primary kino-btn-primary",
            //     type: "button",
            //     href:`${profile}`,
            //     target:'_blank',
            //     html: "Resume"
            // });

            // let modalFooter = $("<div/>", {
            //     class: "modal-footer border-0",
            //     html: [cancelDownloadBtn, startDownloadBtn]
            // });

            // let modalContent = $("<div/>", {
            //     class: 'modal-content',
            //     html: [modalHeader, modalBody, modalFooter]
            // });

            // let modalDialog = $("<div/>", {
            //     class: "modal-dialog modal-dialog-centered",
            //     role: "document",
            //     html: modalContent
            // });

            // rec.resumeRecModal = $("<div/>", {
            //     class: "modal fade",
            //     id: "kinoDownloadReady",
            //     tabindex: "-1",
            //     role: "dialog",
            //     'aria-labelledby': "kinoDownloadReady",
            //     'aria-hidden': "true",
            //     'data-backdrop': "static",
            //     'data-keyboard': "false",
            //     html: modalDialog
            // }).on('keyup',function(e){
            //     if (e.keyCode == 27) {
            //         rec.removeModal(rec.resumeRecModal);
            //     }
            // });

            // $('body').append(rec.resumeRecModal);
            // rec.resumeRecModal.modal('show');

    };

    serviceUnavailableModal(){
        // MODAL
        //commented for later
        // let profile = 'https://kino.live/profile';
        let rec = this;
        rec.recUnavailableModal && rec.removeModal(rec.recUnavailableModal);

        // let resumeRecordSvg = $("<a/>", {
        //     class: 'ready-download-svg-container',
        //     type: "button",
        //     href:`#`,
        //     target:'_blank',
        //     html: rec.kinoRecorderSvg
        // });

        // let resumeDownloadIcon = $("<div/>", {
        //     class: 'ready-download-icon',
        //     html: resumeRecordSvg
        // });

        let readyDownloadText = $("<div/>", {
            class: 'ignore-drag ready-download-text',
            html: 'Kino Recorder is temporary unavailable. Please try again in a few minutes.'
        });
        let modalBody = $("<div/>", {
            class: 'modal-body mx-auto p-0',
            html: [readyDownloadText]
        });

        let closeModalBtn = $("<button/>", {
            class: "close-button-modal-kino",
            type: "button",
            style: "font-size: 1.2rem; top: 8px;",
            html: `<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10"><path fill="gray" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19
            0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34
            120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12
            3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12
            3.12-8.19 0-11.31L193.94 256z"></path>
        </svg>`
        }).on('click', e => {
            rec.removeModal(rec.recUnavailableModal);
        });

        let modalSubHeader = $("<span/>", {
            class: "ignore-drag",
            html: 'Service Unavailable'
        });

        let modalHeader = $("<div/>", {
            class: "modal-header modal-header-kino",
            html: [`<h4 class="mt-2 mb-0 text-center ignore-drag" style="font-weight: 600;">Kino Recorder</h4>`, modalSubHeader, closeModalBtn]
        });

        let cancelDownloadBtn = $('<button/>',{
            class: "btn btn-primary kino-btn-secondary",
            type: "button",
            html: "close",
            'data-dismiss': "modal"
        })
        // let startDownloadBtn = $('<a/>', {
        //     class: "btn btn-primary kino-btn-primary",
        //     type: "button",
        //     href:`${profile}`,
        //     target:'_blank',
        //     html: "Resume"
        // });

        let modalFooter = $("<div/>", {
            class: "modal-footer border-0",
            html: [cancelDownloadBtn/*, startDownloadBtn*/]
        });

        let modalContent = $("<div/>", {
            class: 'modal-content',
            html: [modalHeader, modalBody, modalFooter]
        });

        let modalDialog = $("<div/>", {
            class: "modal-dialog modal-dialog-centered",
            role: "document",
            html: modalContent
        });

        rec.recUnavailableModal = $("<div/>", {
            class: "modal fade",
            id: "kino-recorder-unavailable",
            tabindex: "-1",
            role: "dialog",
            'aria-labelledby': "kino-recorder-unavailable",
            'aria-hidden': "true",
            'data-backdrop': "static",
            'data-keyboard': "false",
            html: modalDialog
        }).on('keyup',function(e){
            if (e.keyCode == 27) {
                rec.removeModal(rec.recUnavailableModal);
            }
        });

        $('body').append(rec.recUnavailableModal);
        rec.recUnavailableModal.modal('show');

};


disableLiveStream(){
    live_stream.disabled=true;
    if($("#live-stream-modal-btn")){
        $("#live-stream-modal-btn").attr({
            "data-toggle": "tooltip",
            "data-placement": "top",
            "data-original-title":
                "Live streaming is disabled while a recording is active"
        }).addClass("button-disabled");

        if( live_stream.channelSelectionModal.hasClass('minimized-modal') ||
        live_stream.singleServiceAuthModal.hasClass('minimized-modal') ||
        live_stream.servicesModal.hasClass('minimized-modal') ||
        live_stream.previewStreamModal.hasClass('minimized-modal') ||
        live_stream.facebookSelectionModal.hasClass('minimized-modal') ||
        live_stream.streamTitleModal.hasClass('minimized-modal') ||
        live_stream.pendingStreamModal.hasClass('minimized-modal') ||
        live_stream.resumeModal.hasClass('minimized-modal')){

            if(live_stream.channelSelectionModal.hasClass('minimized-modal')){
                $(`#channel-list-selection-modal`).removeClass('fadeOutDown minimized-modal');
                $(`#channel-list-selection-modal`).modal('hide');
                Video.minimizedContent.removeMinimizedBadge('channel-list-selection-modal');
            }
            if(live_stream.singleServiceAuthModal.hasClass('minimized-modal')){
                // Video.minimizedContent.maximizeModal('single-service-auth-modal');
                $(`#single-service-auth-modal`).removeClass('fadeOutDown minimized-modal');
                $(`#single-service-auth-modal`).modal('hide');
                Video.minimizedContent.removeMinimizedBadge('single-service-auth-modal');
            }
            if(live_stream.servicesModal.hasClass('minimized-modal')){
                // Video.minimizedContent.maximizeModal('live-stream-modal');
                $(`#live-stream-modal`).removeClass('fadeOutDown minimized-modal');
                $(`#live-stream-modal`).modal('hide');
                Video.minimizedContent.removeMinimizedBadge('live-stream-modal');
            }
            if(live_stream.facebookSelectionModal.hasClass('minimized-modal')){
                // Video.minimizedContent.maximizeModal('facebook-service-selection-modal');
                $(`#facebook-service-selection-modal`).removeClass('fadeOutDown minimized-modal');
                $(`#facebook-service-selection-modal`).modal('hide');
                Video.minimizedContent.removeMinimizedBadge('facebook-service-selection-modal');
            }
            if(live_stream.previewStreamModal.hasClass('minimized-modal')){
                // Video.minimizedContent.maximizeModal('preview-stream-modal');
                $(`#preview-stream-modal`).removeClass('fadeOutDown minimized-modal');
                $(`#preview-stream-modal`).modal('hide');
                Video.minimizedContent.removeMinimizedBadge('preview-stream-modal');
            }
            if(live_stream.streamTitleModal.hasClass('minimized-modal')){
                // Video.minimizedContent.maximizeModal('stream-title-modal');
                $(`#stream-title-modal`).removeClass('fadeOutDown minimized-modal');
                $(`#stream-title-modal`).modal('hide');
                Video.minimizedContent.removeMinimizedBadge('stream-title-modal');
            }
            if(live_stream.pendingStreamModal.hasClass('minimized-modal')){
                // Video.minimizedContent.maximizeModal('pending-stream-modal');
                $(`#pending-stream-modal`).removeClass('fadeOutDown minimized-modal');
                $(`#pending-stream-modal`).modal('hide');
                Video.minimizedContent.removeMinimizedBadge('pending-stream-modal');
            }
        }
    }
};

enableLiveStream(){
    live_stream.disabled=false;
    if($("#live-stream-modal-btn")){
        $("#live-stream-modal-btn").removeAttr(
            "data-toggle data-placement data-original-title"
        ).removeClass("button-disabled");
    }
};

}
